import React, { useState, useCallback, useMemo } from 'react';
import FocusTrap from 'focus-trap-react';
import { FocusTrapContext } from './FocusTrapContext';
export function FocusTrapContainer(props) {
    const [containerElements, setElements] = useState([]);
    const register = useCallback((elem) => {
        setElements((prev) => {
            if (prev.includes(elem))
                return prev;
            return [...prev, elem];
        });
    }, []);
    const unregister = useCallback((elem) => {
        setElements((prev) => prev.filter((v) => v !== elem));
    }, []);
    const contextValue = useMemo(() => ({
        register,
        unregister,
    }), [register, unregister]);
    return (React.createElement(FocusTrapContext.Provider, { value: contextValue },
        React.createElement(FocusTrap, Object.assign({}, props, { containerElements: [
                // eslint-disable-next-line react/destructuring-assignment
                ...(props.containerElements ?? []),
                ...containerElements,
            ] }))));
}
//# sourceMappingURL=FocusTrapContainer.js.map